import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const ReturnsAndExchanges = () => {
    return (
        <>
            <Helmet>
                <title>Returns & Exchanges | Bliss Water Technology</title>
                <meta
                    name="description"
                    content="Learn about the returns and exchanges policy of Bliss Water Technology. Return or exchange your water filter or product within 15 days under our guidelines."
                />
                <meta
                    name="keywords"
                    content="returns policy, exchanges, Bliss Water return, water filter return, defective item exchange, Bliss Water refund"
                />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <HeadingNavbar />
            <Header />
            <Container>
                <Row className="my-md-5 my-4">
                    <Col>
                        <Card.Title className="text-center fs-2 mb-3 fw-bold">
                            Returns & Exchanges
                        </Card.Title>
                        <Card>
                            <Card.Body>
                                <Card.Text as="div">
                                    <section>
                                        <h5 className="fw-bold">Return Policy</h5>
                                        <p>
                                            At Bliss Water Technology, we want you to be fully
                                            satisfied with your purchase. If you are not satisfied
                                            with your product, you may return it within 15 days of
                                            receipt for a full refund, subject to the conditions
                                            below.
                                        </p>
                                        <p>
                                            To be eligible for a return, the product must be unused,
                                            in the same condition that you received it, and in its
                                            original packaging.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Exchanges</h5>
                                        <p>
                                            We accept exchanges only for defective, damaged, or
                                            incorrect items. If you receive a faulty product, please
                                            contact us immediately with details and photographic
                                            evidence so we can arrange an exchange or replacement.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">How to Return</h5>
                                        <p>
                                            To initiate a return or exchange, please contact our customer support team at{" "}
                                            <a href="mailto:blisswatertechnology@gmail.com">blisswatertechnology@gmail.com</a> or call us at{" "}
                                            <a href="tel:+919265199516">+91 92651 99516</a> with your order number and reason for return.
                                        </p>
                                        <p>
                                            We will provide you with detailed instructions on how to send the product back to us.
                                            Please do not send your purchase back without prior authorization.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Return Shipping Costs</h5>
                                        <p>
                                            Return shipping costs are the responsibility of the
                                            customer unless the product is defective or we sent an
                                            incorrect item. In such cases, we will cover the return
                                            shipping charges.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Refunds</h5>
                                        <p>
                                            Once your returned item is received and inspected, we will
                                            notify you of the approval or rejection of your refund.
                                            Approved refunds will be processed to the original payment
                                            method within 7 business days.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Non-returnable Items</h5>
                                        <p>
                                            For hygiene and safety reasons, certain items like used
                                            water filters or opened consumables cannot be returned or
                                            exchanged.
                                        </p>
                                    </section>

                                    <section>
                                        <h5 className="fw-bold">Contact Us</h5>
                                        <p>
                                            If you have any questions about returns or exchanges,
                                            please contact us at{" "}
                                            <a href="mailto:blisswatertechnology@gmail.com">
                                                blisswatertechnology@gmail.com
                                            </a>{" "}
                                            or call our support team at{" "}
                                            <a href="tel:+919265199516">+91 92651 99516</a>. We're here to help!
                                        </p>
                                    </section>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
};

export default ReturnsAndExchanges;
